module.exports = __webpack_public_path__ + "media/flags/mr-90b04447.svg";